module.exports = __webpack_public_path__ + "rfm-avatar-almost-loyal.svg?acaaa958b501f4a151fa60719dde6102";